module.exports = __webpack_public_path__ + "img/monitor_active.ccde4a89.svg";